import { createContext } from "use-context-selector"

import { createProvider } from "domain/createProvider"
import { getDataGridInitState } from "domain/utils"

const initState = getDataGridInitState()

export const TeamContext = createContext(initState)

export const TeamProvider = createProvider(TeamContext, initState)
